import React from "react";

export const AmountLoader = (prop) => {
  const CounterBody = () => {
    return (
      <div className="digit-wrapper">
        <span className="digit">0</span>
        <span className="digit">1</span>
        <span className="digit">2</span>
        <span className="digit">3</span>
        <span className="digit">4</span>
        <span className="digit">5</span>
        <span className="digit">6</span>
        <span className="digit">7</span>
        <span className="digit">8</span>
        <span className="digit">9</span>
        <span className="digit">0</span>
      </div>
    );
  };
  return (
    <div className="randomnumber-count">
      <p>{prop?.initialAmount}</p>
      <>
        {Array.from({ length: prop?.rotation || 0 }, (_, index) => (
          <div key={index} className="time-part">
            <CounterBody />
          </div>
        ))}
      </>
    </div>
  );
};
